import Important from "../assets/images/thumbs_up.png";
import NotImportant from "../assets/images/thinking_face.png";

const IndustryMatchImportance = [
  {
    id: 1,
    value: "Important.",
    // longValue: 'Important. I\'m looking to learn from others in my industry',
    longValue: "Very important",
    backendValue: true,
    hasImage: true,
    image: Important,
  },
  {
    id: 2,
    value: "Not important.",
    // longValue: 'Not important. Business is business.',
    longValue: "Not very important",
    backendValue: false,
    hasImage: true,
    image: NotImportant,
  },
];

export default IndustryMatchImportance;
